module.exports = __webpack_public_path__ + "static/img/c10.4692fe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c10.png
// module id = 257
// module chunks = 0 1 2 3 4 5 6 7 8 9